import React from 'react';
import { withRouter } from 'react-router-dom'

let IcFacebook = require('../../../assets/images/ic_facebook.png');


class Footer extends React.Component {

    render() {
        return (
            <div className="footer">
                <div className={'en-footer'}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <ul className="terms-desk">
                                    <li><a className="facebook-icon" href="https://www.facebook.com/dictatools"
                                           target="_blank" rel="noopener noreferrer"><img alt="" src={IcFacebook}/></a></li>
                                    <li><a className="f black link pull-left" href="http://dicta.org.il/tos.html"
                                           target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                                    <li><a className="f black" href="http://dicta.org.il/aboutus-en.html" target="_blank" rel="noopener noreferrer">About
                                        Dicta</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'he-footer'}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <ul className="terms-desk">
                                    <li><a className="f black link pull-left" href="http://dicta.org.il/tos.html"
                                           target="_blank" rel="noopener noreferrer">תנאים ושרותים</a></li>
                                    <li><a className="f black" href="http://dicta.org.il/aboutus-en.html" target="_blank" rel="noopener noreferrer">
                                        צור קשר</a></li>
                                    <li><a className="facebook-icon" href="https://www.facebook.com/dictatools"
                                           target="_blank" rel="noopener noreferrer"><img alt="" src={IcFacebook}/></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/components/home/includes/Footer.js